























import Vue, { VueConstructor } from 'vue'
import { BaseCardTitle } from '@/components'
import { ShippingMethodListItem, ShippingMethodListItemInpostParcel } from './components'
import { IShippingAddress, IShippingMethod, IShippingContactData } from '@/models'
import { ACTIONS_ORDER, STORE_MODULES, MUTATIONS_ORDER } from '@/enums'
import { createNamespacedHelpers } from 'vuex'

const { mapMutations, mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)

interface IShippingMethodWithComponent {
    component: VueConstructor
    method: IShippingMethod
}

export default Vue.extend({
    name: 'OrderShippingForm',

    components: { BaseCardTitle },

    props: {
        shippingAddress: {
            type: Object as () => IShippingAddress,
            required: true,
        },
        shippingContactData: {
            type: Object as () => IShippingContactData,
            required: true,
        },
    },

    data: () => ({
        shippingMethods: undefined as undefined | IShippingMethod[],
        isRequestInProgress: false,
    }),

    computed: {
        shippingMethodsWithComponents(): IShippingMethodWithComponent[] {
            return (
                this.shippingMethods?.map(method => ({
                    component: this.getMethodComponent(method),
                    method,
                })) ?? []
            )
        },
    },

    watch: {
        shippingAddress: {
            immediate: true,
            handler() {
                this.reset()
            },
        },

        shippingContactData: {
            immediate: true,
            handler() {
                this.reset()
            },
        },
    },

    methods: {
        ...mapMutations({ setShipping: MUTATIONS_ORDER.SET_SHIPPING }),
        ...mapActions({
            fetchShippingMethods: ACTIONS_ORDER.FETCH_SHIPPING_METHODS,
            createAndSetShipping: ACTIONS_ORDER.CREATE_AND_SET_SHIPPING,
        }),

        getMethodComponent({ type }: IShippingMethod): VueConstructor {
            switch (type) {
                case 'InPostPaczkomatShippingMethod':
                    return ShippingMethodListItemInpostParcel
                default:
                    return ShippingMethodListItem
            }
        },

        async reset() {
            this.setShipping()
            this.shippingMethods = undefined
            this.shippingMethods = await this.fetchShippingMethods(this.shippingAddress)

            if (this.shippingMethods?.length) {
                this.createAndSetShipping(this.shippingMethods![0])
            }
        },
    },
})
